<template>
    <div class="ecartpay-hero">
        <div class="ecartpay-hero__text-container">
            <div class="text-left">
                <img class="ecartpay-hero__logo" alt="Tendencys"
                    src="@/assets/images/logos/ecart-pay-color.svg" />
                <h2 class="ecartpay-hero__title">
                    {{ $t('Simplify your digital transactions with Ecart Pay!') }}
                </h2>
                <ul class="ecartpay-hero__list">
                    <li>{{ $t('Payment processor') }}</li>
                    <li>{{ $t('Payment links') }}</li>
                    <li>{{ $t('Invoice generator') }}</li>
                    <li>{{ $t('Payment gateway integrator') }}</li>
                </ul>
                <router-link class="ecartpay-hero__link" to="/#apps">
                    {{ $t('See applications') }}
                </router-link>
            </div>
        </div>
        <div class="ecartpay-hero__image-container">
            <img class="ecartpay-hero__image" alt="Tendencys"
                src="@/assets/images/auth/hero-ecart-pay.webp" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'EcartPayHero',
};
</script>

<style lang="scss">
.ecartpay-hero {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__text-container {
        display: flex;
        flex-grow: 1;
        justify-content: flex-start;
        align-items: center;
    }

    &__logo {
        height: auto;
        margin-bottom: 20px;
        max-width: 370px;
        width: 100%;
    }

    &__title {
        color: #2F2F33;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 12px;
        max-width: 400px;
    }

    &__list {
        color: #2F2F33;
        font-size: 14px;
        font-weight: 400;
        padding-left: 16px;
    }

    &__image-container {
        margin-bottom: -30px;
        margin-left: auto;
        margin-right: -65px;
        width: 100%;
    }

    &__image {
        width: 100%;
        height: auto;
    }

    &__link {
        color: #68AE34;
        font-size: 14px;
        font-weight: 600;
    }
}
</style>
